"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var AbstractValidationPlugin_1 = __importDefault(require("./AbstractValidationPlugin"));
console.debug('INFO DateValidatonPlugin.ts loaded');
var DateValidationPlugin = /** @class */ (function (_super) {
    __extends(DateValidationPlugin, _super);
    function DateValidationPlugin(field) {
        var _this = _super.call(this, field) || this;
        _this.field = field;
        return _this;
    }
    DateValidationPlugin.prototype.runCustomValidation = function () {
        if (this._isDisabledDate()) {
            this.field.setCustomValidity('No Valid Date.');
            return false;
        }
        this.field.setCustomValidity('');
        return true;
    };
    DateValidationPlugin.prototype._isDisabledDate = function () {
        /* eslint-disable @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access */
        var parentElement = this.field.parentElement.parentElement;
        var flatpickr = parentElement._flatpickr;
        // @ts-ignore
        var disableRules = flatpickr.config.disable;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
        var pickedDate = flatpickr.parseDate(this.field.value);
        if (disableRules && disableRules.length > 0) {
            for (var i = 0; i < disableRules.length; i++) {
                var rule = disableRules[i];
                if ((rule && typeof rule === 'string') || typeof rule === 'number' || rule instanceof Date) {
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
                    if (pickedDate.getTime() === flatpickr.parseDate(rule, undefined).getTime()) {
                        return true;
                    }
                }
                else if (rule && typeof rule === 'object' && rule.from && rule.to) {
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
                    var from = flatpickr.parseDate(rule.from);
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
                    var to = flatpickr.parseDate(rule.to);
                    if (pickedDate <= to && pickedDate >= from) {
                        return true;
                    }
                }
                else if (rule && typeof rule === 'function') {
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
                    if (rule(pickedDate)) {
                        return true;
                    }
                }
            }
        }
        return false;
    };
    DateValidationPlugin.prototype.isValid = function () {
        return this.runCustomValidation();
    };
    DateValidationPlugin.prototype._getMessageAttribute = function () {
        return 'data-date-error-message';
    };
    DateValidationPlugin.prototype._getDefaultMessage = function () {
        return 'This date is not available.';
    };
    return DateValidationPlugin;
}(AbstractValidationPlugin_1.default));
exports.default = DateValidationPlugin;
